import { Link, useLocation } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { findRouteSeo } from '../lib/seo';
interface BreadcrumbsProps {
  /** Override the current-page label (used by the not-found page). */
  label?: string;
  className?: string;
}

/** Home > current page. Matches the BreadcrumbList structured data. */
export function Breadcrumbs({
  label,
  className = ''
}: BreadcrumbsProps) {
  const {
    pathname
  } = useLocation();
  const current = label ?? findRouteSeo(pathname)?.breadcrumb;
  if (!current) return null;
  return <nav aria-label="Breadcrumb" className={className} data-id="element-89" data-mp="1ugopd7ey1d6o">
      <ol className="flex flex-wrap items-center gap-1.5 text-[15px] font-semibold text-ink/75" data-id="element-90" data-mp="28ewva4tyjotz">
        <li data-id="element-91" data-mp="23fahnua7w6kn">
          <Link to="/" className="rounded-md underline decoration-ink/25 underline-offset-4 transition-colors duration-150 ease-out hover:text-ink hover:decoration-coral" data-id="element-92" data-mp="23eijqct5dwr7">
            Home
          </Link>
        </li>
        <li aria-hidden="true" data-id="element-93" data-mp="l9uq7lwidzmv">
          <ChevronRightIcon className="h-4 w-4" data-id="element-94" data-mp="lam85tx6nyuo" />
        </li>
        <li data-id="element-95" data-mp="lc785z29o9zx">
          <span aria-current="page" className="text-ink" data-id="element-96" data-mp="q8ns0h2fo277">
            {current}
          </span>
        </li>
      </ol>
    </nav>;
}